import React, { useState, useEffect } from 'react';
import {
  Container,
  Table,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { APIgetPaymentProducts } from '../../api/Payments';

import Loading from '../../components/Loading';

const AdminPanelPricing = () => {
  const [products, setProducts] = useState(null);
  const [loading, setLoading] = useState(true);

  const intl = useIntl();

  useEffect(() => {
    APIgetPaymentProducts().then((response) => {
      const allProducts = response.data?.products || {};
      if (allProducts.free) {
        delete allProducts.free;
      }
      setProducts(response.data?.products);
      setLoading(false);
    });
  }, []);

  return (
    <div className="main-content split-content page-pricing">
      <div className="split-content-wrapper">
        <Container fluid>
          <header className="page-header">
            <h2 className="page-title">
              <i className="far fa-circle-dollar" />
              {intl.formatMessage({ defaultMessage: 'Pricing' })}
            </h2>
          </header>
          <div className="content-wrapper admin-panel-wrapper admin-pricing-wrapper">
            {loading ? (
              <Loading />
            ) : (
              <Table>
                <tbody>
                  <tr>
                    {Object.keys(products).map((productId) => {
                      const product = products[productId];
                      return (
                        <td key={`name-${productId}`}>
                          <h5>{product.name}</h5>
                        </td>
                      );
                    })}
                  </tr>
                  <tr>
                    {Object.keys(products).map((productId) => {
                      const product = products[productId];
                      return (
                        <td key={`features-${productId}`}>
                          <ul>
                            {product.features.map(feature => (
                              <li key={feature.slug}>
                                {feature.name}
                              </li>
                            ))}
                          </ul>
                        </td>
                      );
                    })}
                  </tr>
                </tbody>
              </Table>
            )}
          </div>
        </Container>
      </div>
    </div>
  );
};

export default AdminPanelPricing;
